// Smooth scroll on anchors
var smoothScroll = function(){

	$('.smoothScroll').on('click', function(){

			var anchor       = $(this).attr('href');
			var header       = $('header');
			var headerOffset = header.height();

			$('html, body').animate({
				scrollTop:($(anchor).offset().top - headerOffset)
			}, 600);
			return false;
		});

}


$(document).ready(function(){
    smoothScroll();
});
